import {
  CLEAR_MESSAGE,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT,
  SET_MESSAGE,
  SET_CONTRACTS,
} from "./types";
import * as auth from "../../api/api";
export const login = (user) => (dispatch) => {
  localStorage.setItem("user", JSON.stringify(user));
  dispatch({
    type: LOGIN_SUCCESS,
    payload: { user: user },
  });
  dispatch({
    type: CLEAR_MESSAGE,
  });
  if (!user) {
    dispatch({
      type: LOGIN_FAIL,
    });

    const message = "Login failed";

    dispatch({
      type: SET_MESSAGE,
      payload: message,
    });
  }
};

export const contracts = (contracts) => (dispatch) => {
  dispatch({
    type: SET_CONTRACTS,
    payload: { contracts: contracts },
  });
};

export const logout = () => (dispatch) => {
  auth.logout();

  dispatch({
    type: LOGOUT,
  });
};
